module.exports = __webpack_public_path__ + "static/media/martinique.69e02da6.svg";